import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar'; 
import '../css/HowToUse.css';
import questionImg from '../components/img/how_to/question.png';
import ask from '../components/img/how_to/ask.png';
import List from '../components/img/how_to/List.png';
import financial from '../components/img/how_to/financial.png';
import text from '../components/img/how_to/text.png';
import prompt_generate from '../components/img/how_to/prompt_generate.png';

function HowToUse() {
  return (
    <div className="how-to-use-container">
      {/* サイドバー */}
      <Sidebar />

      {/* メインコンテンツ */}
      <div className="how-to-use-content">
        <h2 className="how-to-title">InsightNote の基本的な使い方</h2>
        <p>
          InsightNote は AI、データ・アナリティクスを活用した金融データ/企業分析プラットフォームです。
          <br />
          対話によるデータの可視化や原因の調査や分析が可能です。
          <br />
          データソースは有価証券報告書、決算短信などの適時開示資料などです。
          <br />
          <br />
          チャット画面やダッシュボードのチャット欄に知りたいことを入力してください。
          <br />
          AIとの会話で思いがけない発見が見つかるかもしれません。
        </p>

        <p>
        <br />
        <b>テキスト情報の解析</b>
        <br />
        有価証券報告書や適時開示資料の要約や比較などの解析を行うことができます。
        <br />
        単一書類の要約はもちろん、複数社の文書の比較分析や複数期間の文書の比較などを行うことができます。
        <br />
        </p>
        <div className="image-container">
          <img src={text} alt="How To Use Illustration" className="how-to-image" />
        </div>
        <br />
        <br />

        <b>該当企業の抽出</b>
        <br />
        業界や見たい企業の条件をリストアップすることで、その条件にあった企業を抽出することができます。
        <div className="image-container">
          <img src={List} alt="How To Use Illustration" className="how-to-image" />
        </div>
        <br />
        <br />

        <b>財務データの表示</b>
        <br />
        企業の財務データを取得することができます。
        <br />
        単純な勘定科目だけでなく、営業利益率や売上高等の前年比、3年前との比較など、自由に計算して取得することができます。
        <br />
        <div className="image-container">
          <img src={financial} alt="How To Use Illustration" className="how-to-image" />
        </div>
        <br />
        <br />

        <b>金融知識の質問</b>
        <br />
        ROE とは？、PER って何？、どうやって成長企業を見つければ良い？といった一般的な質問にわかりやすく回答します。
        <br />
        証券コードから企業名を検索するなどといったこともできます。
                {/* 画像挿入 */}
        <div className="image-container">
          <img src={ask} alt="How To Use Illustration" className="how-to-image" />
        </div>
        <br />
        <br />

        <b>企業ダッシュボードの表示</b>
        <br />
        知りたい企業の証券コードから企業名を検索しダッシュボードを表示するなどといったこともできます。
        {/* 画像挿入 */}
        <div className="image-container">
          <img src={questionImg} alt="How To Use Illustration" className="how-to-image" />
        </div>
        <br />
        <br />

        <b>プロンプトを生成する</b>
        <br />
        <p>
          AI がどのような回答をするのかは、投げかけるプロンプトに応じて決まります。
          <br />
          プロンプト生成機能 を使うと選択した分析の目的や領域に応じてプロンプトが生成されます。
          <br />
          どのようなプロンプトを投げたらいいか迷った時にお使いください。
        </p>
          {/* 画像挿入 */}
          <div className="image-container">
            <img src={prompt_generate} alt="How To Use Illustration" className="how-to-image" />
          </div>
        {/* <p>
          <br />
          単語1つで大きく回答が変化するのが生成AI です。
          <br />
          そのためプロンプトに関する研究は日々行われています。
          <br />
          より深い分析のために、プロンプトの知識は非常に重要です。
          <br />
          <Link
            to="/prompts"
            style={{
              color: "#78A75A",
              fontWeight: "bold",
              textDecoration: "none",
            }}
            onMouseOver={(e) => (e.target.style.color = "#48752C")}
            onMouseOut={(e) => (e.target.style.color = "#78A75A")}
          >
            こちらのサイト
          </Link>
          では、企業分析での事例とともにプロンプトの基礎知識を掲載しています。
          <br />
        </p> */}
      </div>
      
    </div>
  );
}

export default HowToUse;